import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../styles/menu.scss";
import { FaRegEdit } from "react-icons/fa";
import { toast } from "react-toastify";

const Campanha = () => {
    const [campanhas, setCampanhas] = useState([]);
    const [clientes, setClientes] = useState([]); // Armazenar os clientes
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(""); // "edit" ou "add"
    const [currentCampanha, setCurrentCampanha] = useState(null);
    const [newCampanha, setNewCampanha] = useState({
        NOME_CAMPANHA: "",
        DESCRICAO: "",
        ID_CLIENTE: "", 
    });

    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Buscar campanhas
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL; // Definir aqui
        const fetchCampanhas = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) throw new Error("Usuário não autenticado.");

                const response = await axios.get(`${API_URL}/api/menu/campanhas`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                setCampanhas(response.data);
            } catch (error) {
                toast.error("Erro ao buscar campanhas:", error.response?.data || error.message);
                if (error.response?.status === 401) navigate("/login");
            }
        };

        fetchCampanhas();
    }, [navigate]);

    // Buscar clientes
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL; // Definir aqui
        const fetchClientes = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) throw new Error("Usuário não autenticado.");

                const response = await axios.get(`${API_URL}/api/menu/clientes`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                setClientes(response.data);
            } catch (error) {
                toast.error("Erro ao buscar clientes:", error.response?.data || error.message);
            }
        };

        fetchClientes();
    }, []);

    const handleEdit = (campanha) => {
      setCurrentCampanha({
        ...campanha,
        ID_CLIENTE: campanha.ID_CLIENTE || "", // Certifica que o ID_CLIENTE está definido
    });
    setModalType("edit");
    setModalOpen(true);
   
    };

    const handleAdd = () => {
        setNewCampanha({ NOME_CAMPANHA: "", DESCRICAO: "", ID_CLIENTE: "" });
        setModalType("add");
        setModalOpen(true);
        
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("authToken");

            if (modalType === "edit") {
                const payload = {
                    NOME_CAMPANHA: currentCampanha.NOME_CAMPANHA,
                    DESCRICAO: currentCampanha.DESCRICAO,
                    ID_CLIENTE: currentCampanha.ID_CLIENTE,
                };

                await axios.put(
                    `${API_URL}/api/menu/campanhas/${currentCampanha.ID_CAMPANHA}`,
                    payload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                toast.success("Campanha editada com sucesso!"); // Mensagem de sucesso ao editar
            } else if (modalType === "add") {
                const payload = {
                    NOME_CAMPANHA: newCampanha.NOME_CAMPANHA,
                    DESCRICAO: newCampanha.DESCRICAO,
                    ID_CLIENTE: newCampanha.ID_CLIENTE,
                };

                await axios.post(`${API_URL}/api/menu/campanhas`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                toast.success("Campanha criada com sucesso!"); // Mensagem de sucesso ao criar
            }

            setModalOpen(false);

            // Recarregar campanhas
            const response = await axios.get(`${API_URL}/api/menu/campanhas`, {
                headers: { Authorization: `Bearer ${token}` },
                
            });
            setCampanhas(response.data);
        } catch (error) {
            toast.error("Erro ao salvar campanha:", error.response?.data || error.message);
        }
    };

    const handleCancel = () => {
        setModalOpen(false);
        setCurrentCampanha(null);
    };

    return (
        <div className="page-container">
            <h1>Campanhas</h1>
            <div className="container-login100-form-btn">
                <button className="login100-form-btn_cad" onClick={handleAdd}>
                    Nova Campanha
                </button>
            </div>
            <table className="campanha-table">
                <thead>
                    <tr>
                        <th className="col-cliente">Nome do Cliente</th>
                        <th className="col-campanha">Nome da Campanha</th>
                        <th className="col-descricao">Link</th>
                        <th className="col-acoes">Ações</th>
                    </tr>
                </thead>
                <tbody>
    {campanhas.map((campanha) => (
        <tr key={campanha.ID_CAMPANHA}>
            <td className="col-cliente">{campanha.NOME_CLIENTE}</td>
            <td className="col-campanha">{campanha.NOME_CAMPANHA}</td>
            <td className="col-descricao" title={campanha.DESCRICAO}>
                {campanha.DESCRICAO}
            </td>
            <td className="col-acoes">
                <button onClick={() => handleEdit(campanha)}>
                    <FaRegEdit />
                </button>
            </td>
        </tr>
    ))}
</tbody>

            </table>

            {/* Modal */}
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        {modalType === "edit" && <h2>Editar Campanha</h2>}
                        {modalType === "add" && <h2>Cadastrar Campanha</h2>}
                        <label>
                            Cliente:
                            <select
    className="styled-select"
    value={
        modalType === "edit"
            ? currentCampanha?.ID_CLIENTE // Seleciona o cliente da campanha atual
            : newCampanha.ID_CLIENTE
    }
    onChange={(e) => {
        if (modalType === "edit") {
            setCurrentCampanha({
                ...currentCampanha,
                ID_CLIENTE: e.target.value,
            });
        } else {
            setNewCampanha({
                ...newCampanha,
                ID_CLIENTE: e.target.value,
            });
        }
    }}
>
    <option value="">Selecione um cliente</option>
    {clientes.map((cliente) => (
        <option key={cliente.ID_CLIENTE} value={cliente.ID_CLIENTE}>
            {cliente.NOME_CLIENTE}
        </option>
    ))}
</select>

                        </label>
                        <label>
                            Nome da Campanha:
                            <input
                                type="text"
                                value={
                                    modalType === "edit"
                                        ? currentCampanha?.NOME_CAMPANHA
                                        : newCampanha.NOME_CAMPANHA
                                }
                                onChange={(e) => {
                                    if (modalType === "edit") {
                                        setCurrentCampanha({
                                            ...currentCampanha,
                                            NOME_CAMPANHA: e.target.value,
                                        });
                                    } else {
                                        setNewCampanha({
                                            ...newCampanha,
                                            NOME_CAMPANHA: e.target.value,
                                        });
                                    }
                                }}
                            />
                        </label>
                        <label>
                            link:
                            <textarea
                                value={
                                    modalType === "edit"
                                        ? currentCampanha?.DESCRICAO
                                        : newCampanha.DESCRICAO
                                }
                                onChange={(e) => {
                                    if (modalType === "edit") {
                                        setCurrentCampanha({
                                            ...currentCampanha,
                                            DESCRICAO: e.target.value,
                                        });
                                    } else {
                                        setNewCampanha({
                                            ...newCampanha,
                                            DESCRICAO: e.target.value,
                                        });
                                    }
                                }}
                            />
                        </label>
                        <div className="modal-actions">
                            <button onClick={handleSave}>Salvar</button>
                            <button onClick={handleCancel}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Campanha;
